// Generated by CoffeeScript 2.7.0
// bodyCanScroll is required
var BodyScrollMixin;

export default BodyScrollMixin = {
  mounted: function() {
    return this._toggleBodyScroll();
  },
  watch: {
    bodyCanScroll: function() {
      return this._toggleBodyScroll();
    }
  },
  methods: {
    _toggleBodyScroll: function() {
      if (this.bodyCanScroll) {
        return Skylark.Helpers.App.enableScrollOnBody();
      } else {
        return Skylark.Helpers.App.disableScrollOnBody();
      }
    }
  }
};
